import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
	isEqual, isEmpty, isUndefined, isArray,
} from 'lodash';
import classNames from 'classnames';
import { ControlLabel, InputGroup } from 'react-bootstrap';
import MaskedInput from 'react-text-mask';
import { CARD_ICONS, MASK_VALUE } from '@utils/constants';

class TextInput extends Component {
	constructor(props) {
		super(props);

		this.debounceTimeout = null;
		this.debounceFunction = null;
		this.state = {
			value : props.value,
		};
	}

	UNSAFE_componentWillReceiveProps = ({ value : nextValue }) => {
		const { value } = this.state;
		if (!isEqual(nextValue, value)) this.setState({ value : nextValue });
	}

	shouldComponentUpdate = ({ rawErrors, schema : { maskedValue, cardType } }, { value }) => {
		const lastState = this.state;
		const lastProps = this.props;
		return (
			!isEqual(value, lastState.value)
		|| !isEqual(rawErrors, lastProps.rawErrors)
		|| !isEqual(maskedValue, lastProps.schema.maskedValue)
		|| !isEqual(cardType, lastProps.schema.cardType)
		);
	}

	onChange = ({ target : { value } }) => {
		this.setState({ value });

		/**
		 * Clear debounceTimeout to prevent updating the Store
		 * multiple times using the JS native function
		 * clearTimeout
		 */
		if (this.debounceTimeout !== null) clearTimeout(this.debounceTimeout);

		this.debounceFunction = () => {
			const { onChange } = this.props;
			onChange(value);
		};
		this.debounceTimeout = setTimeout(this.debounceFunction, 300);
	}

	render() {
		const {
			placeholder,
			label : fieldName,
			options : {
				label,
				wrapperClassName,
				type,
				inputClassName,
				maskedField,
				inputGroupClassName,
				large,
				labelFont,
				subLabel,
				onBlur,
				customMask,
			},
			rawErrors,
			schema : {
				maskedValue,
				cardType,
			},
		} = this.props;
		const { value } = this.state;
		let mask = maskedValue || MASK_VALUE[maskedField];

		if (!isUndefined(customMask) && isArray(customMask)) mask = customMask;

		return (
			<div className={wrapperClassName}>
				<ControlLabel className={classNames(labelFont, 'font-size-15 color-gray-mine-shaft', { 'color-pink-brink' : !isEmpty(rawErrors) })}>
					{ label }
					<If condition={subLabel}>
						<small className="font-size-10 margin-left-5">{ subLabel }</small>
					</If>
				</ControlLabel>
				<InputGroup
					bsSize={large ? 'large' : undefined}
					className={inputGroupClassName}
				>
					<MaskedInput
						id={`label_${type}_${placeholder || ''}`}
						type={type}
						value={value}
						guide={false}
						placeholder={placeholder}
						onChange={this.onChange}
						onBlur={onBlur}
						mask={mask}
						className={classNames('font-size-14 color-blue-bayoux font-regular', inputClassName, { 'input-error' : !isEmpty(rawErrors) })}
					/>
					<If condition={fieldName === 'cardNumber'}>
						<img
							className="card-type-image"
							src={CARD_ICONS[cardType] || CARD_ICONS.default}
							alt="card icon"
						/>
					</If>
				</InputGroup>
			</div>
		);
	}
}

TextInput.propTypes = {
	label       : PropTypes.string,
	onChange    : PropTypes.func.isRequired,
	value       : PropTypes.string,
	placeholder : PropTypes.string,
	rawErrors   : PropTypes.array,
	options     : PropTypes.shape({
		customMask          : PropTypes.array,
		label               : PropTypes.string,
		wrapperClassName    : PropTypes.string,
		inputClassName      : PropTypes.string,
		inputGroupClassName : PropTypes.string,
		maskedField         : PropTypes.string,
		icon                : PropTypes.string,
		type                : PropTypes.string,
		large               : PropTypes.bool,
		labelFont           : PropTypes.string,
		subLabel            : PropTypes.string,
		onBlur              : PropTypes.func,
	}),
	schema : PropTypes.shape({
		cardType    : PropTypes.string,
		maskedValue : PropTypes.any,
	}),
};

TextInput.defaultProps = {
	label       : '',
	value       : '',
	placeholder : '',
	rawErrors   : [],
	options     : {
		label               : '',
		wrapperClassName    : '',
		inputClassName      : '',
		inputGroupClassName : '',
		icon                : '',
		type                : 'text',
		large               : true,
		labelFont           : 'font-regular',
		subLabel            : '',
	},
	schema : {
		cardType    : undefined,
		maskedValue : undefined,
	},
};

export default TextInput;
